'use client'

import { PostProcessor } from '.'

/**
 * NOTE: This function references the global document variable because it looks for elements by id.
 * @param id Element id
 */
const triggerTab = (id: string) => {
  document.getElementById(id)?.click()
}

/**
 * NOTE: This function references the global document variable because it looks for elements by id.
 * @param root Root element to parse.
 * @returns
 */
const attachMegaTabControls = (root: Element) => {
  const tabMenu = root.getElementsByClassName('js-tab-menu')
  const megaTabMenu = root.getElementsByClassName('js-mega-tab-menu')

  // If page contains any tab-menus
  if (tabMenu.length) {
    // For every tab-menu present on the page
    for (const tabMenuContainer of tabMenu) {
      const tabBtn = tabMenuContainer.getElementsByClassName('c-tab-menu__tab-btn')
      // for (var j = 0; j < tabBtn.length; j++) {
      for (const tabBtnContainer of tabBtn) {
        if (!tabBtnContainer.getAttribute('data-bold-placeholder')) {
          tabBtnContainer.setAttribute('data-bold-placeholder', tabBtnContainer.textContent ?? '')
        }

        // When a click occurs on one of the tabs
        tabBtnContainer.addEventListener('click', () => {
          // Get the current active tab
          const currentTabMenu = tabBtnContainer.closest('.c-tab-menu')
          const currentTab = currentTabMenu?.getElementsByClassName(
            'c-tab-menu__tab-btn--active'
          )[0]
          const currentPane = currentTabMenu?.getElementsByClassName('c-tab-menu__pane--active')[0]
          // Remove the active state from the current tab and set the new tab to active
          currentTab?.classList.remove('c-tab-menu__tab-btn--active')
          currentPane?.classList.remove('c-tab-menu__pane--active')
          tabBtnContainer.classList.add('c-tab-menu__tab-btn--active')
          // Find the activated tabs pane and activate that
          const tabPaneId = (tabBtnContainer as HTMLElement).dataset.content
          if (tabPaneId) {
            const tabPane = document.getElementById(tabPaneId)
            tabPane?.classList.add('c-tab-menu__pane--active')
          }
        })
      }
    }
  }

  // If page contains any mega-tab-menus
  if (megaTabMenu.length) {
    // For every mega-tab-menu present on the page
    for (const tabContainer of megaTabMenu) {
      const tabBtn = tabContainer.getElementsByClassName('c-mega-tab-menu__tab-btn')
      for (const tabBtnContainer of tabBtn) {
        if (!tabBtnContainer.getAttribute('data-bold-placeholder')) {
          tabBtnContainer.setAttribute('data-bold-placeholder', tabBtnContainer.textContent ?? '')
        }

        // When a click occurs on one of the tabs
        tabBtnContainer.addEventListener('click', () => {
          // Get the current active tab
          const currentmegaTabMenu = tabBtnContainer.closest('.c-mega-tab-menu')
          const currentTab = currentmegaTabMenu?.getElementsByClassName(
            'c-mega-tab-menu__tab-btn--active'
          )[0]
          const currentPane = currentmegaTabMenu?.getElementsByClassName(
            'c-mega-tab-menu__pane--active'
          )[0]
          // Remove the active state from the current tab and set the new tab to active
          currentTab?.classList.remove('c-mega-tab-menu__tab-btn--active')
          currentPane?.classList.remove('c-mega-tab-menu__pane--active')
          tabBtnContainer.classList.add('c-mega-tab-menu__tab-btn--active')
          // Find the activated tabs pane and activate that
          const tabPaneId = (tabBtnContainer as HTMLElement).dataset.content
          if (tabPaneId) {
            const tabPane = document.getElementById(tabPaneId)
            tabPane?.classList.add('c-mega-tab-menu__pane--active')
          }
        })
      }
    }
  }

  if (tabMenu.length || megaTabMenu.length) {
    const currentUrl = location.href
    if (currentUrl.includes('#')) {
      const queryParam = currentUrl.split('#')[1]

      if (!queryParam) {
        return
      }

      const el = document.getElementById(queryParam)
      const elIsTabItem = el?.getAttribute('role') === 'tab'

      if (!elIsTabItem) {
        return
      }

      triggerTab(queryParam)
    }
  }
}

export const tabMenuProcessor: PostProcessor = node => {
  attachMegaTabControls(node)
}
